import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { Observable } from 'rxjs';

import { BaseEditFormComponent, GridService, ProductService, ProductUsedIn } from 'tms-lib';

@Component({
  selector: 'app-stock-enquiry-used-in',
  templateUrl: './stock-enquiry-used-in.component.html',
  styleUrl: './stock-enquiry-used-in.component.scss',
})
export class StockEnquiryUsedInComponent implements OnInit {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;

  @Input() productId: string;

  model$: Observable<ProductUsedIn[]>;

  columnDefs: ColDef[] = [
    this.gridService.text('productKey', $localize`Product`),
    this.gridService.text('productTypeDescription', $localize`Product Type`),
    this.gridService.text('productDescription', $localize`Description`),
    this.gridService.text('productOldCode', $localize`Alternate Code`),
    this.gridService.text('owner', $localize`Owner`),
  ];

  constructor(
    private productService: ProductService,
    private gridService: GridService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    if (!this.productId) {
      this.productId = this.route.snapshot.paramMap.get('id');
    }
    this.getModel();
  }

  getModel() {
    this.model$ = this.productService.getProductsUsedIn(this.productId);
  }
}
